import React from 'react';
import { Form, Input, Button, Typography, Space, Divider, App } from 'antd';
import { PhoneOutlined, LockOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

const { Title, Text } = Typography;

const OldLogin = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { oldLogin, loading } = useAuthStore();
  const { message } = App.useApp();

  const onFinish = async (values) => {
    const result = await oldLogin(values.phone, values.password);
    if (result.success) {
      message.success("Muvaffaqiyatli kirdingiz!");
      navigate('/');
    } else {
      message.error(result.message);
    }
  };

  return (
    <div>
      <Title level={3} style={{ marginBottom: 4 }}>
        Kirish
      </Title>
      <Text type="secondary">Telefon raqam va parol bilan kiring</Text>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ marginTop: 24 }}
        size="large"
      >
        <Form.Item
          name="phone"
          label="Telefon raqam"
          rules={[
            { required: true, message: "Telefon raqamni kiriting" },
            {
              pattern: /^(\+998|0)\d{9}$/,
              message: "Format: +998901234567 yoki 0901234567",
            },
          ]}
        >
          <Input prefix={<PhoneOutlined />} placeholder="+998901234567" />
        </Form.Item>

        <Form.Item
          name="password"
          label="Parol"
          rules={[{ required: true, message: "Parolni kiriting" }]}
        >
          <Input.Password prefix={<LockOutlined />} placeholder="Parol" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Kirish
          </Button>
        </Form.Item>
      </Form>

      <Divider style={{ margin: '20px 0' }} />

      <Space orientation="vertical" style={{ width: '100%' }} align="center" size={8}>
        <Text>
          Hisobingiz yo&apos;qmi?{' '}
          <Link to="/auth/register">Ro&apos;yxatdan o&apos;ting</Link>
        </Text>
        <Text type="secondary">yoki</Text>
        <Link to="/auth/otp">
          <Button type="default" block>
            📱 OTP (Telegram) orqali kirish
          </Button>
        </Link>
      </Space>
    </div>
  );
};

export default OldLogin;
